<template>
	<!-- Modal: Out Of Stock -->
	<div :class="modal ? 'modal is-active' : 'modal'">
		<div class="modal-background"></div>
		<div class="modal-card is-small">
			<header class="modal-card-head">
				<button @click="closeModal()" class="delete" aria-label="close"></button>
				<p class="modal-card-title">Are You sure!</p>
			</header>
			<section class="modal-card-body has-text-centered ph20">

				<img class="has-text-centered mt15 mb20" src="@/assets/img/icon-empty.png" alt="Empty">
				<p class="has-text-centered is-size-14 modal-text" v-if="product">Would you like to  remove <strong>{{ product ? product.product_name : '' }}</strong> from cart ?</p>
			</section>
			<footer class="modal-card-foot is-flex-column">
				<button @click.prevent="removeItem(product)" class="button is-large hover-opacity-7 bg-secondary text-white is-full-width mr0 mb20">Yes, Confirm</button>
				<a href="#" @click.prevent="closeModal()" class="has-text-centered">No, Cancel</a>
			</footer>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'RemoveCartItem',
  data() {
    return {
      modal: false,
      product: {},
    };
  },

  mounted() {
    bus.$on('show-modal-remove-cart-item', (payload) => {
      this.modal = payload.modal;
      this.product = payload.product;
    })
  },

  computed: {
    ...mapGetters({
      vg_selectedStore: "location/selected",
    }),
  },
  
  beforeDestroy() {
    bus.$off('show-modal-remove-cart-item');
  },

  methods: {
    async removeItem(product) {
 
      // Hit an api to remove cart items
      let res = await CartApis.delete({
        cart_product_id: product.id,
        location_id: this.$store.getters['location/selected'].id ? this.$store.getters['location/selected'].id : '',
      });
     
      if(res.status == 200){
        
        if(this.$store.getters.getLoggedInUserToken){
          // remove from vbout , for logged in user
          VboutApis.removeCartItem({
            cartid: this.$store.getters['cart/id'],
            productid: product.id,
            variation: { 
              variation_id: product.selected_variant.id, 
            },
          }, this.vg_selectedStore.id);
        }
        
        // G tracking remove cart item
        this.$gtag.event('remove_from_cart', { 
          items: [
            {
              id: this.product.location_product_id,
              name: this.product.product_name, 
              brand: this.product.brand_name ? this.product.brand_name : null,
              category: this.product.category_name ? this.product.category_name : null,
              variant: this.product.selected_variant.size ? this.product.selected_variant.size : null,
              quantity: parseInt(this.product.unit),
              price: this.product.price,
            }
          ]
        });
        this.closeModal();
      }
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 200 ? 'success' : 'error',
      });
     
    },

   closeModal() {
     this.modal = false;
   },

   ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>